// src/slices/2-location/reducer.js
import { createSlice } from "@reduxjs/toolkit";
import { createLocation, updateLocation, getAllLocations, getLocationById, deleteLocation } from "./thunk";
import { toast } from "react-toastify";

const initialState = { locations: [], location: null, loading: false, error: null, message: null };

const locationSlice = createSlice({
  name: "location",
  initialState,
  reducers: {
    clearLocation: (state) => {
      state.location = null;
      state.error = null;
      state.message = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // 🔵 Get All Locations
      .addCase(getAllLocations.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllLocations.fulfilled, (state, action) => {
        state.loading = false;
        state.locations = action.payload || [];
      })
      .addCase(getAllLocations.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        // toast.error(`Failed to load locations`);
      })

      // 🟣 Get One Location
      .addCase(getLocationById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getLocationById.fulfilled, (state, action) => {
        state.loading = false;
        state.location = action.payload || null;
      })
      .addCase(getLocationById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        toast.error(`Failed to fetch location`);
      })

      // 🟢 Create Location
      .addCase(createLocation.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createLocation.fulfilled, (state, action) => {
        state.loading = false;
        state.locations.push(action.payload);
        toast.success("Location created successfully");
      })
      .addCase(createLocation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        toast.error(`${action.payload}`);
      })

      // 🟡 Update Location
      .addCase(updateLocation.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateLocation.fulfilled, (state, action) => {
        state.loading = false;
        const updated = action.payload;
        state.locations = state.locations.map((loc) => (loc.id === updated.id ? updated : loc));
        toast.success("Location updated successfully");
      })

      .addCase(updateLocation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        toast.error(`${action.payload}`);
      })
      // 🔴 Delete Location
      .addCase(deleteLocation.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteLocation.fulfilled, (state, action) => {
        state.loading = false;
        const deletedId = action.payload.id;
        state.locations = state.locations.filter((loc) => loc.id !== deletedId);
        toast.success("Location deleted successfully");
      })
      .addCase(deleteLocation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        toast.error(`${action.payload}`);
      });
  }
});

export const { clearLocation } = locationSlice.actions;
export default locationSlice.reducer;
